<template>
  <div>
    <h4 class="text-muted font-weight-light">Reset your Password</h4>
    <b-form @submit="onSubmit" v-if="show">
      <b-form-group id="ResetPasswordGroup" label label-for="resetPassword">
        <b-form-input
          id="RegisterPassword"
          type="password"
          v-model="form.password"
          required
          :state="passwordState"
          aria-describedby="RegisterPassword RegisterPasswordFeedback"
          minlength="6"
          placeholder="*******"
        ></b-form-input>
        <b-form-text id="ResetPasswordFeedback">
          <!-- This will only be shown if the preceeding input has an invalid state -->
          Create a Password, 6 or more characters
        </b-form-text>
      </b-form-group>
      <b-button type="submit" variant="primary" class="mr-2">Reset Password</b-button>
      <b-button :to="{name:'sign-in'}" variant="link" class="mr-2">Cancel</b-button>
    </b-form>
  </div>
</template>

<script>
export default {
  name: 'reset',
  data() {
    return {
      form: {
        password: ''
      },
      show: true
    }
  },
  computed: {
    passwordState() {
      return this.form.password.length > 2 ? true : null
    }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault()
      // console.log(window.location)
      // console.log(this.$route.query.oobCode)
      this.$store.dispatch('auth/passwordReset', {
        form: this.form,
        code: this.$route.query.oobCode
      })
    }
  }
}
</script>

<!-- b-form-1.vue -->

<style scoped>
</style>
